import { render, staticRenderFns } from "./RouteInfoV2RouteList.vue?vue&type=template&id=55004856&scoped=true&"
import script from "./RouteInfoV2RouteList.vue?vue&type=script&lang=ts&"
export * from "./RouteInfoV2RouteList.vue?vue&type=script&lang=ts&"
import style0 from "./RouteInfoV2RouteList.vue?vue&type=style&index=0&id=55004856&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55004856",
  null
  
)

export default component.exports